// extracted by mini-css-extract-plugin
export default {"alert":"BcVan11iiTkZ6qMmb3r5","docList":"FyHyrJ0nkYRVkCeMmApw","listItem":"AJPpeJreDwJbQHqdVWDP"};